import React, { useState } from "react";
import { label } from "./label";

const STATUS_LABELS = { draft: "Draft", sent: "Sent", won: "Won", lost: "Lost" };
const STATUS_COLORS = {
  draft: { bg: "var(--rf-bg)", border: "var(--rf-border)", text: "var(--rf-muted)" },
  sent:  { bg: "#0f2a1e", border: "#16a34a", text: "#86efac" }, // no green/success token exists in this app (see src/theme.js) — literal, matching every other green badge in src/App.js
  won:   { bg: "#0f2a1e", border: "#16a34a", text: "#86efac" },
  lost:  { bg: "var(--rf-bg)", border: "var(--rf-danger)", text: "var(--rf-danger)" },
};

// Presentational only — App.js owns loading jobs and computing jobTotals
// (per-job rollups, which need rawBytes + evalFormulasWithReport, both
// async and Supabase-backed).
// creating (final fix wave, item 12): a New is in flight, so the button is
// disabled until it finishes (App.js's createNewJob also refuses a second).
export default function JobsList({ jobs, jobTotals, canEdit, onOpen, onNew, creating = false, vocabulary = {} }) {
  const [statusFilter, setStatusFilter] = useState("");
  const visible = statusFilter ? jobs.filter((j) => (j.status || "draft") === statusFilter) : jobs;

  return (
    <section>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16 }}>
        <div>
          <div style={{ fontSize: 20, fontWeight: 700, color: "var(--rf-text-heading)" }}>{label("jobs", 2, vocabulary)}</div>
          <div style={{ fontSize: 13, color: "var(--rf-text-dim)" }}>Every bid, from first takeoff to sent proposal.</div>
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          <select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            style={{ background: "var(--rf-bg)", border: "1px solid var(--rf-border)", borderRadius: 7, color: "var(--rf-text)", fontSize: 13, padding: "6px 10px" }}
          >
            <option value="">All statuses</option>
            {Object.entries(STATUS_LABELS).map(([k, label]) => <option key={k} value={k}>{label}</option>)}
          </select>
          {canEdit && (
            <button onClick={onNew} disabled={creating} style={{ background: "var(--rf-primary)", border: "none", borderRadius: 7, color: "white", fontSize: 13, fontWeight: 600, padding: "8px 16px", cursor: creating ? "not-allowed" : "pointer", opacity: creating ? 0.6 : 1 }}>
              {creating ? "Creating..." : "+ New"}
            </button>
          )}
        </div>
      </div>

      {visible.length === 0 && (
        <div style={{ color: "var(--rf-text-dim)", fontSize: 14, padding: "24px 0" }}>
          {statusFilter ? "No jobs with this status." : "No jobs yet. Click New to start a bid."}
        </div>
      )}

      {visible.length > 0 && (
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
          <thead>
            <tr style={{ borderBottom: "1px solid var(--rf-border)", textAlign: "left", color: "var(--rf-muted)", fontSize: 11, textTransform: "uppercase" }}>
              <th style={{ padding: "8px 6px" }}>Name</th>
              <th style={{ padding: "8px 6px" }}>Property</th>
              <th style={{ padding: "8px 6px" }}>Status</th>
              <th style={{ padding: "8px 6px", textAlign: "right" }}>Total</th>
              <th style={{ padding: "8px 6px" }}>Last updated</th>
              <th style={{ padding: "8px 6px" }} />
            </tr>
          </thead>
          <tbody>
            {visible.map((j) => {
              const status = j.status || "draft";
              const colors = STATUS_COLORS[status] || STATUS_COLORS.draft;
              const totals = jobTotals?.[j.id];
              return (
                <tr key={j.id} style={{ borderBottom: "1px solid var(--rf-surface)" }}>
                  <td style={{ padding: "10px 6px", color: "var(--rf-text-heading)", fontWeight: 600 }}>{j.name || "Untitled Job"}{(j.revision || 1) > 1 ? ` (Rev ${j.revision})` : ""}</td>
                  <td style={{ padding: "10px 6px", color: "var(--rf-text-soft)" }}>{j.property || "-"}</td>
                  <td style={{ padding: "10px 6px" }}>
                    <span style={{ fontSize: 10, fontWeight: 700, color: colors.text, background: colors.bg, border: `1px solid ${colors.border}`, borderRadius: 4, padding: "2px 7px", textTransform: "uppercase" }}>
                      {STATUS_LABELS[status] || status}
                    </span>
                  </td>
                  <td style={{ padding: "10px 6px", textAlign: "right", color: "var(--rf-text)" }}>
                    {totals && !totals.incomplete && totals.total != null ? `$${totals.total.toFixed(2)}` : "-"}
                  </td>
                  <td style={{ padding: "10px 6px", color: "var(--rf-text-dim)" }}>{j.updatedAt ? new Date(j.updatedAt).toLocaleDateString() : "-"}</td>
                  <td style={{ padding: "10px 6px", textAlign: "right" }}>
                    <button onClick={() => onOpen(j)} style={{ background: "transparent", border: "1px solid var(--rf-border)", borderRadius: 6, color: "var(--rf-accent)", fontSize: 12, padding: "5px 12px", cursor: "pointer" }}>
                      Open →
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </section>
  );
}
